import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Dialog } from '@knockrentals/knock-shared-web-v2';

export const TITLE = 'An unexpected error has occurred';

const ErrorDialog = ({ closeDialog, errorMessage, title = TITLE }) => {
  const isOpen = Boolean(errorMessage);
  return (
    <Dialog
      onClose={closeDialog}
      open={isOpen}
      size="sm"
      title={title}
      withCloseIcon
    >
      <Dialog.Content>{errorMessage}</Dialog.Content>

      <Dialog.Actions>
        <Button onClick={closeDialog}>Close</Button>
      </Dialog.Actions>
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  title: PropTypes.string,
};

export default ErrorDialog;
